module.exports = __webpack_public_path__ + "static/media/recovery-img-4.de5db1e5.png";